import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    border: '1px solid #EBEBEB',
  },
  img: {
    height: '20px',
    width: '20px',
  },
  text: {
    marginLeft: '7px',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '100%',
    color: '#000F1C',
  },
}));
